"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const notfoundContainer = {
    display: 'grid',
    placeItems: 'center',
    height: `calc(100vh - ${constants_1.navbarStyle.height})`
};
const notfound404 = {
    fontSize: '100px'
};
const notfoundTitle = {
    fontSize: 'xx-large'
};
const notfoundButton = {
    paddingTop: 10,
    paddingBottom: 10
};
const notFoundImage = {
    maxWidth: 550,
    maxHeight: 400,
    marginBottom: 20
};
const notFoundSubContainer = {
    display: 'grid',
    placeItems: 'center'
};
exports.default = {
    notfoundContainer,
    notfound404,
    notfoundTitle,
    notfoundButton,
    notFoundImage,
    notFoundSubContainer
};
